import Layout from "./Layout";
import React, { useState } from "react";
import { Profile, Security, Membership, Billing, Setting } from "./component";
import { useParams } from "react-router-dom";
import { useRef, useEffect } from "react";
import { mixGetV1 } from "services/mixin";

const UserAccount: React.FC = () => {   

    const [profile, setProfile] = useState(null)
    const getProfile = async () => {
        const res = await mixGetV1('/api/v1/fe/customer/profile')
            if(res.status) {
                setProfile(res.data)
        }
    }
    useEffect(() => {
        getProfile()
    }, [])

    const {section} = useParams();

    const profileRef = useRef<HTMLDivElement>(null);
    const securityRef = useRef<HTMLDivElement>(null);
    const membershipRef = useRef<HTMLDivElement>(null);
    const billingRef = useRef<HTMLDivElement>(null);
    const settingRef = useRef<HTMLDivElement>(null);

    const refMap: Record<string, React.RefObject<HTMLDivElement>> = {
        profile: profileRef,
        security: securityRef,
        membership: membershipRef,
        billing: billingRef,
        setting: settingRef,
    };

    useEffect(() => {
        if (section && refMap[section]) {
        refMap[section].current?.scrollIntoView({ behavior: "smooth", block: "center" });
        } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
        }
    }, [section]);
   
    return(
        <Layout>
            <p className="title">User Account</p>
            <div className="list-card">
                <div ref={profileRef}><Profile /></div>
                <div ref={securityRef}><Security /></div>
                <div ref={membershipRef}><Membership user={profile} /></div>
                <div ref={billingRef}><Billing user={profile} /></div>
                {/* <div ref={settingRef}><Setting /></div> */}
            </div>
        </Layout>
    )
}

export default UserAccount